import * as React from 'react'
import MediaQuery from 'react-responsive'

interface Props {
  maxWidth?: number
  minWidth?: number
}

export const MediaQueryOwn: React.SFC<Props> = ({ children, maxWidth, minWidth }) => {
  return (
    <MediaQuery maxWidth={maxWidth} minWidth={minWidth}>
      {children}
    </MediaQuery>
  )
}



// WEBPACK FOOTER //
// ./src/views/components/MediaQueryOwn/MediaQueryOwn.tsx